import { createSlice } from '@reduxjs/toolkit';

// ----------------------------------------------------------------------

export const loggedin = createSlice({
  name: 'loggedin',
  initialState: null,
  reducers: {
    SET_LOGGEDIN: () => {
      return true;
    },
    DELETE_LOGGEDIN: () => {
      return null;
    }
  }
});
export const { SET_LOGGEDIN, DELETE_LOGGEDIN } = loggedin.actions;

// ----------------------------------------------------------------------

export const token = createSlice({
  name: 'token',
  initialState: null,
  reducers: {
    SET_TOKEN: (state, action) => {
      return action.payload;
    },
    DELETE_TOKEN: () => {
      return null;
    }
  }
});
export const { SET_TOKEN, DELETE_TOKEN } = token.actions;

// ----------------------------------------------------------------------

export const account = createSlice({
  name: 'account',
  initialState: null,
  reducers: {
    SET_ACCOUNT: (state, action) => {
      return action.payload;
    },
    DELETE_ACCOUNT: () => {
      return null;
    }
  }
});

export const { SET_ACCOUNT, DELETE_ACCOUNT } = account.actions;

// ----------------------------------------------------------------------

export const group = createSlice({
  name: 'group',
  initialState: { id: null, name: null },
  reducers: {
    SET_GROUP: (state, action) => {
      return action.payload;
    },
    DELETE_GROUP: () => {
      return { id: null, name: null };
    }
  }
});

export const { SET_GROUP, DELETE_GROUP } = group.actions;

// ----------------------------------------------------------------------

export const devices = createSlice({
  name: 'devices',
  initialState: [],
  reducers: {
    SET_DEVICES: (state, action) => {
      return action.payload;
    },
    DELETE_DEVICES: () => {
      return [];
    }
  }
});

export const { SET_DEVICES, DELETE_DEVICES } = devices.actions;

// ----------------------------------------------------------------------

export const device = createSlice({
  name: 'device',
  initialState: null,
  reducers: {
    SET_DEVICE: (state, action) => {
      return action.payload;
    },
    DELETE_DEVICE: () => {
      return null;
    }
  }
});

export const { SET_DEVICE, DELETE_DEVICE } = device.actions;

// ----------------------------------------------------------------------

export const loader = createSlice({
  name: 'loader',
  initialState: null,
  reducers: {
    SET_LOADER: () => {
      return true;
    },
    DELETE_LOADER: () => {
      return null;
    }
  }
});

export const { SET_LOADER, DELETE_LOADER } = loader.actions;

// ----------------------------------------------------------------------

export const rangesLocationSensors = createSlice({
  name: 'rangesLocationSensors',
  initialState: null,
  reducers: {
    SET_RANGES_LOCATION_SENSORS: (state, action) => {
      return action.payload;
    },
    DELETE_RANGES_LOCATION_SENSORS: () => {
      return null;
    }
  }
});

export const { SET_RANGES_LOCATION_SENSORS, DELETE_RANGES_LOCATION_SENSORS } = rangesLocationSensors.actions;

// ----------------------------------------------------------------------

export const rangesLocationPredictions = createSlice({
  name: 'rangesLocationPredictions',
  initialState: null,
  reducers: {
    SET_RANGES_LOCATION_PREDICTIONS: (state, action) => {
      return action.payload;
    },
    DELETE_RANGES_LOCATION_PREDICTIONS: () => {
      return null;
    }
  }
});

export const { SET_RANGES_LOCATION_PREDICTIONS, DELETE_RANGES_LOCATION_PREDICTIONS } = rangesLocationPredictions.actions;

// ----------------------------------------------------------------------

export const rangesSensor = createSlice({
  name: 'rangesSensor',
  initialState: null,
  reducers: {
    SET_RANGES_SENSOR: (state, action) => {
      return action.payload;
    },
    DELETE_RANGES_SENSOR: () => {
      return null;
    }
  }
});

export const { SET_RANGES_SENSOR, DELETE_RANGES_SENSOR } = rangesSensor.actions;

// ----------------------------------------------------------------------

export const rangesRecentlySensor = createSlice({
  name: 'rangesRecentlySensor',
  initialState: null,
  reducers: {
    SET_RANGES_RECENTLY_SENSOR: (state, action) => {
      return action.payload;
    },
    DELETE_RANGES_RECENTLY_SENSOR: () => {
      return null;
    }
  }
});

export const { SET_RANGES_RECENTLY_SENSOR, DELETE_RANGES_RECENTLY_SENSOR } = rangesRecentlySensor.actions;

// ----------------------------------------------------------------------

export const rangesAnalysis = createSlice({
  name: 'rangesAnalysis',
  initialState: null,
  reducers: {
    SET_RANGES_ANALYSIS: (state, action) => {
      return action.payload;
    },
    DELETE_RANGES_ANALYSIS: () => {
      return null;
    }
  }
});

export const { SET_RANGES_ANALYSIS, DELETE_RANGES_ANALYSIS } = rangesAnalysis.actions;